export const getLinkTarget = (url) => {
  if (!url) return

  if (url.startsWith('http') && !url.includes(window.location.hostname)) {
    return '_blank'
  }
  return '_self'
}
